import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import {
  CenteredContainer,
  Link,
  Title,
  Type,
  Text,
} from '@nerdwallet/currency';
import Hero from '../../employee-branding/hero/hero';
import CompanyJobListTile from './company-job-list-tile';
import DepartmentMappings from '../../../lib/company-content-src/department-mappings';
import NotFound from '../not-found';

import styles from './companyJobList.module.less';

const CompanyJobList = ({ jobs, currentDept }) => {
  const renderedJobs = jobs.map((job) => (
    <CompanyJobListTile job={job} key={`item-${job.id}`} />
  ));
  const mappedDepartment = DepartmentMappings[currentDept];

  if (!mappedDepartment) {
    return <NotFound errorType="job" />;
  }

  return (
    <React.Fragment>
      <div
        className={classNames([
          classes('margin-bottom-4'),
          classes('margin-bottom-5--wide'),
        ])}
      >
        <Hero
          backgroundColor="#E3FAF2"
          title={mappedDepartment.name}
          copy={mappedDepartment.body}
          imageUrlMobile={mappedDepartment.imageUrlMobile}
          imageUrlDesktop={mappedDepartment.imageUrlDesktop}
          showCareerBreadcrumbs
          careerBreadcrumbLevel="2"
          careerBreadcrumbDepartment={mappedDepartment.name}
        />
      </div>
      <CenteredContainer className={styles.joblistCont}>
        {jobs.length > 0 ? (
          <React.Fragment>
            <Title
              size="small"
              className={classNames([
                classes('margin-bottom-3'),
                classes('margin-bottom-5--wide'),
                classes('text-align-center'),
                classes('display-block'),
                classes('margin-horizontal-auto'),
              ])}
              component="h2"
            >
              Current openings
            </Title>
            <div className={styles.joblistHdr}>
              <Type default uppercase size="1" color="neutral-dark">
                role
              </Type>
              <Type default uppercase size="1" color="neutral-dark">
                location
              </Type>
            </div>
            <div>{renderedJobs}</div>
          </React.Fragment>
        ) : (
          <div className={styles.noJobs}>
            <Title
              size="small"
              className={styles.noJobsTextCont}
              component="h2"
            >
              No current openings
            </Title>
            <div className={styles.noJobsTextCont}>
              <Text>
                We don&apos;t have any openings, but let us know if you are
                interested.
              </Text>
            </div>
            <div className={styles.noJobsLink}>
              <Link href="mailto:jobs@nerdwallet.com">Get in touch</Link>
            </div>
          </div>
        )}
      </CenteredContainer>
    </React.Fragment>
  );
};

CompanyJobList.displayName = 'Company Job List';

CompanyJobList.propTypes = {
  jobs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      location: PropTypes.string,
    })
  ),
  currentDept: PropTypes.string,
};

export default CompanyJobList;
